export default __webpack_public_path__ + "static/media/phcnAbj.4b184106.svg";